import * as React from 'react';
import CertificationCore from '../AfrCore/CertificationCore';

const Certification = (props: any) => {

    return (
        <React.Fragment>
            <CertificationCore userRole="ENTITY_USER" />
        </React.Fragment>
    );
}

export default Certification;